module.exports = __webpack_public_path__ + "images/feature/20171023-1-27a755c38c2d89f8e15012ca279ad372.png";